const EnumValue = {
  print: ({ node }) => node.name
};

module.exports = EnumValue;
